import {
  FlexibleBlockBrickAvatar,
  FlexibleBlockBrickAvatarStyle,
  FlexibleBlockBrickImage,
  FlexibleBlockProps,
  FlexibleBlockTemplateHeroEvent,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getHeroEventBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateHeroEvent>[] => {
  const brickImage: FlexibleBlockBrickImage = {
    ...brickCommon,
    brickType: 'image',
    brickName: 'Cover Image',
    switchable: true,
    src: '/assets/img/blocks/events/alex_and_mia_date.png',
    className: ['max-w-md', 'ml-auto'],
  };

  const brickAvatar: FlexibleBlockBrickAvatar = {
    ...brickCommon,
    brickType: 'avatar',
    brickName: 'Avatar settings',
    src: '/assets/img/blocks/avatar/avatar.png',
    name: 'Amelia Wells',
    description: 'Your Wedding Assistant',
    style: FlexibleBlockBrickAvatarStyle.RING,
    className: ['justify-end'],
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
    },
  };

  return [
    {
      title: 'Hero',
      template: { type: 'hero-event', view: 'basic' },
      bricks: [
        { ...brickImage, index: 0 },
        { ...brickAvatar, index: 1 },
      ],
      className: ['min-h-72'],
      wrapper: getWrapperProps('none'),
    },
  ];
};
